import { useEffect } from "react";

import { checkAndSendEvents } from "../analytics";

export const useSendEvents = () => {
  useEffect(() => {
    checkAndSendEvents();
  }, []);
};
